<template>
  <div
    class="messages-container"
    :class="{ 'has-giveaway-banner': hasGiveawaysBanner }"
  >
    <PinnedMessages />
    <div class="messages scrollable" ref="messages">
      <Message
        :user="user"
        v-for="(message, index) in messages"
        :key="message.id"
        :message="message"
        :isLastMessageFromSameUser="isLastMessageFromSameUser(message, index)"
        :isPrevMessageUserSame="isPrevMessageUserSame(message, index)"
      />
    </div>
    <div class="chat-errors" v-if="chatErrors.length">
      <NotificationBanner
        v-for="chatError in chatErrors"
        :key="chatError.message"
      >
        {{ chatError.message }}
      </NotificationBanner>
    </div>
    <form class="message-input" ref="formRef" @submit.prevent="sendMessage">
      <MentionInput
        ref="mentionInput"
        :disabled="!user.id"
        v-model="text"
        :asyncSearch="searchUsers"
        @submit="() => $refs.formRef.requestSubmit()"
      />
      <Button
        v-show="!isScrolled"
        @click="() => scrollToBottom(true)"
        class="show-last"
        type="primary"
        style="width: 20px; height: 20px"
      >
        <Arrow />
      </Button>
      <div>
        <SmileIcon
          ref="emojiToggle"
          style="cursor: pointer"
          :disable-skin-tone="true"
          @click="toggleEmojiPicker"
        />
        <EmojiPicker
          v-show="showEmojiPicker"
          v-if="emojiToggleEl"
          v-click-outside="{
            handler: closeEmojiPicker,
            exclude: emojiToggleEl,
          }"
          style="position: absolute; bottom: 40px; left: 0"
          :native="true"
          @select="onSelectEmoji"
          theme="dark"
        />
        <Button
          :disabled="!user.id"
          action="submit"
          type="empty"
          style="width: 20px; height: 20px"
        >
          <SendMessage />
        </Button>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue"
import chatMixin from "@/components/chat/mixins/chat"
// import EmojiPicker from "vue3-emoji-picker"
const EmojiPicker = defineAsyncComponent(() => import("vue3-emoji-picker"))

export default defineComponent({
  name: "GlobalChat",
  mixins: [chatMixin],
  components: { EmojiPicker },
})
</script>

<style lang="scss" scoped>
.show-last {
  position: absolute !important;
  top: -50px;
  right: 10px;
  padding: 15px !important;

  svg {
    transform: rotate(180deg);
  }
}

// @media screen and (max-width: 950px) {
//   .messages-container {
//     &.has-giveaway-banner {
//       max-height: calc(100% - 48px - 32px - 223px - 64px - 4px) !important;
//     }
//   }
// }

.messages-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - var(--header-height) - 83px);
  flex: 1;

  &.has-giveaway-banner {
    max-height: calc(100% - var(--header-height) - 228px);
  }

  .chat-errors {
    margin: 0 8px;
  }

  .messages {
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 8px;
    flex-grow: 1;

    & > :first-child {
      margin-top: auto;
    }
  }

  .pinned-message {
    margin: 8px;
    padding: 12px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.04);
  }

  .pinned-label {
    font-size: 12px;
    opacity: 0.75;
    margin-bottom: 8px;
  }

  .pinned-content {
    margin-bottom: 10px;
  }
  .message-input {
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    box-sizing: border-box;
    padding: 12px 16px;
    margin: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    div {
      display: flex;
      gap: 8px;
      i {
        cursor: pointer;
      }
    }
  }
}
</style>
